import { createSlice } from "@reduxjs/toolkit";

const milleSearchFilter = createSlice({
    name: "mille search filter",
    initialState: {
        location: [],

        enteredInputLocation: ''
    },
    reducers: {
        update_Places_API_location(state, action) {
            let updatingLoc = [...state.location];

            switch (action.payload?.type) {
                case "push":
                    let countryComponent = action.payload?.place?.find(component => component?.types?.includes('country'));
                    if (countryComponent) {
                        if (action.payload?.place) {
                            let new_location = `${action.payload?.place[0]?.long_name},${countryComponent.long_name}`;
                            
                            if (!updatingLoc.includes(new_location)) {
                                updatingLoc[updatingLoc.length] = new_location;
                            }
                        }
                    }
                    break;

                case "delete":
                    let filteredData = updatingLoc.filter(v => v !== action.payload?.deletionData);
                    updatingLoc = filteredData
                    break;

                default:
                    break;
            } 

            return {
                ...state,
                location: updatingLoc,
                enteredInputLocation: ''
            }
        },

        update_input_states(state, action) {
            switch (action.payload?.field) {
                case "location":
                    return {
                        ...state,
                        enteredInputLocation: action.payload?.value
                    }

                default:
                    return;
            }

        },

        reset_all_states_to_default(state, action) {
            return {
                ...state,
                location: []
            }
        }
    }
})

const { actions, reducer } = milleSearchFilter;


export const {
    update_Places_API_location,
    update_input_states,
    reset_all_states_to_default


} = actions

export default reducer;